// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetCompanyProfessionRequestModel from '../../model/get-company-profession-request-model';
import PostCompanyRequestModel from '../../model/post-company-request-model';
import GetCompanyByIdRequestModel from '../../model/get-company-by-id-request-model';
import GetCompanyByExternalIdAsyncRequestModel from '../../model/get-company-by-external-id-async-request-model';
import GetCompanyByExternalIdAndEventIdentifierAsyncRequestModel from '../../model/get-company-by-external-id-and-event-identifier-async-request-model';
import LookupAllCompaniesRequestModel from '../../model/lookup-all-companies-request-model';
import GetCompaniesRequestModel from '../../model/get-companies-request-model';
import GetCompanyForUserRequestModel from '../../model/get-company-for-user-request-model';
import GetCompanyRequestModel from '../../model/get-company-request-model';
import PutCompanyRequestModel from '../../model/put-company-request-model';
import Tdg_CompanyProfessionListPagingResultModel from '../../model/tdg-company-profession-list-paging-result-model';
import Tdg_CompanyDetailModel from '../../model/tdg-company-detail-model';
import Tdg_CompanyUpdateModel from '../../model/tdg-company-update-model';
import Int64LookupListResultModel from '../../model/int64-lookup-list-result-model';
import Tdg_CompanyListPagingResultModel from '../../model/tdg-company-list-paging-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getCompanyProfession(request: GetCompanyProfessionRequestModel, config?: RequestConfig) {
    const requestDTO = GetCompanyProfessionRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-company-profession'] ?? 'tdg/widgets/companies';
    const response = await service.get<any>(endpointPath, {
      query: {
        eventIdentifier: requestDTO.eventIdentifier,
        categoryIds: requestDTO.categoryIds,
        selectedOrganisationId: requestDTO.selectedOrganisationId,
        selectedEventId: requestDTO.selectedEventId,
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_CompanyProfessionListPagingResultModel.toModel(dto));
  },
  /**  */
  async postCompany(request: PostCompanyRequestModel, config?: RequestConfig) {
    const requestDTO = PostCompanyRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-post-company'] ?? 'tdg/widgets/companies';
    const response = await service.post<any>(endpointPath, {
      body: {
        accessToken: requestDTO.accessToken,
        company: requestDTO.company,
        user: requestDTO.user,
      },
      query: {
        eventIdentifier: requestDTO.eventIdentifier,
        existingCompanyId: requestDTO.existingCompanyId,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async getCompanyById(request: GetCompanyByIdRequestModel, config?: RequestConfig) {
    const requestDTO = GetCompanyByIdRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-company-by-id'] ?? 'tdg/widgets/companies/{id}/event/{eventIdentifier}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    endpointPath = endpointPath.replace(/\{eventIdentifier\}/g, `${requestDTO.eventIdentifier}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_CompanyDetailModel.toModel(dto));
  },
  /**  */
  async getCompanyByExternalIdAsync(request: GetCompanyByExternalIdAsyncRequestModel, config?: RequestConfig) {
    const requestDTO = GetCompanyByExternalIdAsyncRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-company-by-external-id-async'] ?? 'tdg/widgets/companies/{externalId}';
    endpointPath = endpointPath.replace(/\{externalId\}/g, `${requestDTO.externalId}`);
    const response = await service.get<any>(endpointPath, {
      query: {
        externalId: requestDTO.externalId,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_CompanyUpdateModel.toModel(dto));
  },
  /**  */
  async getCompanyByExternalIdAndEventIdentifierAsync(request: GetCompanyByExternalIdAndEventIdentifierAsyncRequestModel, config?: RequestConfig) {
    const requestDTO = GetCompanyByExternalIdAndEventIdentifierAsyncRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-company-by-external-id-and-event-identifier-async'] ?? 'tdg/widgets/companies/{externalId}/event/{eventIdentifier}';
    endpointPath = endpointPath.replace(/\{externalId\}/g, `${requestDTO.externalId}`);
    endpointPath = endpointPath.replace(/\{eventIdentifier\}/g, `${requestDTO.eventIdentifier}`);
    const response = await service.get<any>(endpointPath, {
      query: {
        externalId: requestDTO.externalId,
        eventIdentifier: requestDTO.eventIdentifier,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_CompanyUpdateModel.toModel(dto));
  },
  /**  */
  async lookupAllCompanies(request: LookupAllCompaniesRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-lookup-all-companies'] ?? 'tdg/widgets/companies/lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Int64LookupListResultModel.toModel(dto));
  },
  /**  */
  async getCompanies(request: GetCompaniesRequestModel, config?: RequestConfig) {
    const requestDTO = GetCompaniesRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-companies'] ?? 'tdg/admin/companies';
    const response = await service.get<any>(endpointPath, {
      query: {
        eventIdentifier: requestDTO.eventIdentifier,
        selectedOrganisationId: requestDTO.selectedOrganisationId,
        selectedEventId: requestDTO.selectedEventId,
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_CompanyListPagingResultModel.toModel(dto));
  },
  /**  */
  async getCompanyForUser(request: GetCompanyForUserRequestModel, config?: RequestConfig) {
    const requestDTO = GetCompanyForUserRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-company-for-user'] ?? 'tdg/admin/companies/My';
    const response = await service.get<any>(endpointPath, {
      query: {
        userId: requestDTO.userId,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_CompanyUpdateModel.toModel(dto));
  },
  /**  */
  async getCompany(request: GetCompanyRequestModel, config?: RequestConfig) {
    const requestDTO = GetCompanyRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-company'] ?? 'tdg/admin/companies/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_CompanyUpdateModel.toModel(dto));
  },
  /**  */
  async putCompany(request: PutCompanyRequestModel, config?: RequestConfig) {
    const requestDTO = PutCompanyRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-put-company'] ?? 'tdg/admin/companies/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.put<any>(endpointPath, {
      body: {
        id: requestDTO.id,
        links: requestDTO.links,
        creatorId: requestDTO.creatorId,
        creatorName: requestDTO.creatorName,
        created: requestDTO.created,
        modifierId: requestDTO.modifierId,
        modifierName: requestDTO.modifierName,
        modified: requestDTO.modified,
        companyName: requestDTO.companyName,
        externalId: requestDTO.externalId,
        logoDocumentId: requestDTO.logoDocumentId,
        description: requestDTO.description,
        website: requestDTO.website,
        employeesCount: requestDTO.employeesCount,
        apprenticesCount: requestDTO.apprenticesCount,
        apprenticeShipsCount: requestDTO.apprenticeShipsCount,
        professionIds: requestDTO.professionIds,
        companyContactSalutation: requestDTO.companyContactSalutation,
        companyContactFirstName: requestDTO.companyContactFirstName,
        companyContactLastName: requestDTO.companyContactLastName,
        companyContactPhoneNumber: requestDTO.companyContactPhoneNumber,
        companyContactEmail: requestDTO.companyContactEmail,
        companyStreet: requestDTO.companyStreet,
        companyHouseNumber: requestDTO.companyHouseNumber,
        companyZIP: requestDTO.companyZIP,
        companyCity: requestDTO.companyCity,
        companyLocation: requestDTO.companyLocation,
        acceptConditions: requestDTO.acceptConditions,
        companyUserId: requestDTO.companyUserId,
        logoDocumentExternalId: requestDTO.logoDocumentExternalId,
        organisationExternalId: requestDTO.organisationExternalId,
        userName: requestDTO.userName,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
});
